// src/modules/leads/constants.js
export const STATUS_OPTIONS = [
  { value: 'NEW', label: 'New', color: 'default' },
  { value: 'ASSIGNED', label: 'Assigned', color: 'blue' },
  { value: 'CONTACTED', label: 'Contacted', color: 'cyan' },
  { value: 'FOLLOW_UP', label: 'Follow-up', color: 'gold' },
  { value: 'INTERESTED', label: 'Interested', color: 'green' },
  { value: 'NOT_INTERESTED', label: 'Not Interested', color: 'volcano' },
  { value: 'VISIT_SCHEDULED', label: 'Visit Scheduled', color: 'geekblue' },
  { value: 'VISITED', label: 'Visited', color: 'purple' },
  { value: 'CONVERTED', label: 'Converted', color: 'success' },
  { value: 'LOST', label: 'Lost', color: 'red' },
  { value: 'DND', label: 'DND', color: 'magenta' },
  { value: 'INVALID', label: 'Invalid', color: 'default' },
];

export const OUTCOME_OPTIONS = [
  { value: 'CONNECTED', label: 'Connected' },
  { value: 'NO_ANSWER', label: 'No Answer' },
  { value: 'BUSY', label: 'Busy' },
  { value: 'SWITCHED_OFF', label: 'Switched Off' },
  { value: 'WRONG_NUMBER', label: 'Wrong Number' },
  { value: 'CALL_BACK_LATER', label: 'Call Back Later' },
  { value: 'INTERESTED', label: 'Interested' },
  { value: 'NOT_INTERESTED', label: 'Not Interested' },
  { value: 'VISIT_BOOKED', label: 'Visit Booked' },
  // Disabled for now: converting a lead isn't available yet.
  { value: 'CONVERTED', label: 'Converted', disabled: true },
  { value: 'DND', label: 'Do Not Disturb' },
];

// NOTE: Lead "Status" (Hot/Cold) and "Source" are now admin-configurable catalogs
// fetched from the API (fetchLeadStatuses / fetchLeadSources), not fixed lists here.

// Target fields a spreadsheet column can be mapped to.
export const IMPORT_FIELDS = [
  { key: 'name', label: 'Name', required: true },
  { key: 'phone', label: 'Phone', required: true },
  { key: 'altPhone', label: 'Alt Phone' },
  { key: 'email', label: 'Email' },
  { key: 'address', label: 'Address' },
  { key: 'city', label: 'City' },
  { key: 'state', label: 'State' },
  { key: 'pincode', label: 'Pincode' },
  { key: 'leadType', label: 'Lead Type' },
];

export const tagFor = (opts, v) => opts.find((o) => o.value === v) || { label: v, color: 'default' };
